import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

let supabaseClient: SupabaseClient | null = null;

try {
  if (supabaseUrl && supabaseAnonKey) {
    supabaseClient = createClient(supabaseUrl, supabaseAnonKey);
  }
} catch (error) {
  console.error('[SUPABASE] Error creating client:', error);
  supabaseClient = null;
}

export const supabase = supabaseClient as SupabaseClient;

export function getSupabaseClient(): SupabaseClient {
  if (!supabaseClient) {
    throw new Error('Supabase client not initialized. Check your environment variables.');
  }
  return supabaseClient;
}

export function isSupabaseConfigured(): boolean {
  return supabaseClient !== null;
}

export type QuestionnaireSession = {
  id: string;
  session_id: string;
  email: string | null;
  name: string | null;
  form_data: Record<string, any>;
  current_step: number;
  recommendations: any[] | null;
  completed: boolean;
  resume_token: string;
  created_at: string;
  updated_at: string;
  completed_at: string | null;
  user_id: string | null;
};
